export default __webpack_public_path__ + "static/media/three_month@2x.24b8a748.png";